import { Box } from '@mui/material';

import SupervisionSessionNarrative from '../SupervisionSessionNarrative';
import { useClientSupervisionEditable } from '../../../../hooks';
import { SupervisionNoteStatus } from '../../../../constants';
import { useClientNarrativeSuggestion } from './hooks';
import { getClientSupervisionNarrativeSourceKey } from '../types';
import { narrativeTextareaStyle } from '../styles';

import type { IClientSessionNarrativeProps, NarrativeUpdateContext } from '../types';

function SessionNarrative(props: IClientSessionNarrativeProps) {
  const { clientSupervision, showError, onUpdate } = props;
  const isEditable = useClientSupervisionEditable(false);
  const isSupervisionCompleted = clientSupervision?.status === SupervisionNoteStatus.Completed;
  const sourceKey = getClientSupervisionNarrativeSourceKey(clientSupervision);
  const noteId = clientSupervision?.id;
  const { narrativeSuggestionLoading, getNarrativeSuggestion } =
    useClientNarrativeSuggestion(noteId, sourceKey);

  const handleNarrativeUpdate = (
    nextNarrative: string,
    lastAiNarrative?: string,
    context?: NarrativeUpdateContext,
  ) => {
    if (!clientSupervision) return;

    return onUpdate({
      ...clientSupervision,
      session_narrative: nextNarrative,
      ...(lastAiNarrative !== undefined && {
        last_ai_generated_session_narrative: lastAiNarrative,
      }),
    }, context);
  };

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
      <SupervisionSessionNarrative
        dataTestId="clientSupervisionSessionNarrative"
        noteType="97155"
        isEditable={isEditable}
        noteId={noteId}
        narrative={clientSupervision?.session_narrative}
        sourceKey={sourceKey}
        textareaSx={narrativeTextareaStyle(isSupervisionCompleted)}
        showError={showError}
        narrativeSuggestionLoading={narrativeSuggestionLoading}
        onSuggest={getNarrativeSuggestion}
        onUpdate={handleNarrativeUpdate}
      />
    </Box>
  );
}

export default SessionNarrative;
